/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { Box, Button, Dialog, Stack } from "src/components"
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from "src/store";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ButtonMenu, { MenuItem } from "src/components/ButtonMenu";
import KararDestekSlice from "src/store/Slices/KararDestekSlices";
import ButtonPrintMail from "./ButtonPrintMail";
import { useLazyExportPrintFileQuery } from "src/services/Printer/PrinterApi";
import DialogContent from "src/components/DialogContent";
import DialogTitle from "src/components/DialogTitle";

interface IButtonPrintViewerProps {
    onClose?: (a, b) => void;
    children?: React.ReactNode;
};
const menuItems: MenuItem[] = [
    { key: "xls", text: "XLS" },
    { key: "xlsx", text: "XLSX" },
    { key: "rtf", text: "RTF" },
    { key: "docx", text: "DOCX" },
    { key: "mht", text: "MHT" },
    { key: "html", text: "HTML" },
    { key: "txt", text: "Text" },
    { key: "csv", text: "CSV" },
    { key: "png", text: "Image" },
];
const ButtonPrintViewer = (props: IButtonPrintViewerProps): JSX.Element => {
    const [fullScreen, setFullScreen] = useState(false)
    const [src, setSrc] = useState("");
    const kararDestek = useAppSelector(s => s.kararDestek)
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (kararDestek.reportGuid)
            exportFile("pdf")
    }, [kararDestek.reportGuid]);

    const [exportQuery, exportState] = useLazyExportPrintFileQuery()
    const exportFile = async (type: string) => {
        await exportQuery({ guid: kararDestek.reportGuid, type }).unwrap()
            .then(res => {
                if (type === "pdf") {
                    setSrc(window.URL.createObjectURL(res))
                } else {
                    let tempLink = document.createElement('a');
                    tempLink.href = window.URL.createObjectURL(res);
                    tempLink.setAttribute('download', kararDestek.raporSorgu.raporAdi + "." + type);
                    tempLink.click();
                }
            }).catch(e => e);
    };
    const sendMailHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        dispatch(KararDestekSlice.actions.setState({
            ...kararDestek,
            mailOpen: true
        }));
    };
    const exportFileHandler = (item: MenuItem): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            exportFile(item.key);
            resolve(true);
        });
    };
    const fullScreenHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setFullScreen(!(fullScreen));
    };
    const closeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (props.onClose)
            props.onClose({}, "backdropClick");
        dispatch(KararDestekSlice.actions.setState({
            ...kararDestek,
            open: false
        }));
    };
    return (
        <>
            <Dialog open={kararDestek.open} maxWidth={"xl"} fullScreen={fullScreen} onClose={props.onClose}>
                <DialogTitle>
                    {kararDestek.raporSorgu?.raporAdi}
                    <Box sx={{ display: "block", position: "fixed", right: "0px", pr: 1 }}>
                        <Stack direction="row" spacing={1} sx={{}}>
                            <Button customType="mail" variant="outlined" sx={{ width: 30 }} onClick={sendMailHandler}>{" "}</Button>
                            <ButtonMenu loading={exportState.isLoading} menuItems={menuItems} onItemClick={exportFileHandler} sx={{ width: 30 }} variant="outlined">
                                <FileUploadIcon />
                            </ButtonMenu>
                            <Button variant="outlined" sx={{ width: 30 }} onClick={fullScreenHandler}><OpenInFullIcon /></Button>
                            <Button sx={{ width: 30 }} variant="outlined" onClick={closeHandler}><CloseIcon color='error' /></Button>
                        </Stack>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {kararDestek.open && <iframe
                        onLoad={(e) => {
                            //Önizle ekranında tarayıcının yazdırının otomatik açılması istenilmediği için commentlendi
                            // if (kararDestek.print)
                            //     e.currentTarget.contentWindow.print()
                        }}
                        title={kararDestek.raporSorgu.raporsorguId.toString()}
                        src={src}
                        style={
                            {
                                height: fullScreen ? "88vh" : "80vh",
                                width: fullScreen ? "100%" : "100vh"
                            }
                        }
                    >
                    </iframe>}
                </DialogContent>
            </Dialog>
            {kararDestek.mailOpen && <ButtonPrintMail />}
        </>
    )
}
export default ButtonPrintViewer;